// extracted by mini-css-extract-plugin
export default {"allocation":"WZGFBLrdGGJxabpV0ebR","warnings":"iBVTxc4GF3zuSvYEe0E6"};